<template>
<div>
    <div class="mkBox">
        <mavon-editor
        class="md"
        :value="context"
        :subfield="prop.subfield"
        :defaultOpen="prop.defaultOpen"
        :toolbarsFlag="prop.toolbarsFlag"
        :editable="prop.editable"
        :scrollStyle="prop.scrollStyle"
        :boxShadow="prop.boxShadow"
        :ishljs = false
        ></mavon-editor>             
    </div>
</div>
</template>
<script>
export default {
    name:'opendoc',
    data(){
        return{
          context:'',
          apiCode:'',
          empty:false
        }
    },
    computed: {
        // markdown
        prop() {
        let data = {
            subfield: false, // 单双栏模式
            defaultOpen: "preview", //edit： 默认展示编辑区域 ， preview： 默认展示预览区域
            editable: true,
            toolbarsFlag: false,
            scrollStyle: true,
            boxShadow: false
        };
        return data;
        }
    },
    created(){
        if (this.$route.query.apiCode) {
            this.apiCode = this.$route.query.apiCode;
        }
    },
    methods:{

    },
    mounted(){
        this.$axios.get('/openapi-interface/apidoc/content?apiCode='+ this.apiCode)
        .then(res=>{
            this.context = res.data.data;
        })
        .catch(()=>{
            this.$message.error('文档获取失败!')
        })
    }
}
</script>
<style lang="less" scoped>
.mkBox{
    width :1000px;
    margin :0 auto;
}
</style>